import { createAction } from 'redux-actions'

import { SET_PRICETYPE, SET_RETAILER } from './constants'

export const setPriceType = createAction(SET_PRICETYPE)
export const setRetailer = createAction(SET_RETAILER)
